/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaList,
    PrtimesMediaListFromJSON,
    PrtimesMediaListFromJSONTyped,
    PrtimesMediaListToJSON,
} from './PrtimesMediaList';

/**
 * response body of GET prtimes_media_lists/{media_list_id}
 * @export
 * @interface GetMediaListResponse
 */
export interface GetMediaListResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetMediaListResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetMediaListResponse
     */
    message: string;
    /**
     * メディアリスト名
     * @type {string}
     * @memberof GetMediaListResponse
     */
    mediaListName: string;
    /**
     * プレスリリース配信元のメールアドレス
     * @type {string}
     * @memberof GetMediaListResponse
     */
    fromEmail: string;
    /**
     * プレスリリース配信元のメール送信者名（（表示しません）とかある）
     * @type {string}
     * @memberof GetMediaListResponse
     */
    senderName: string;
    /**
     * 形式(Y-m-d\TH:i:sP)
     * @type {string}
     * @memberof GetMediaListResponse
     */
    updatedAt: string;
}

export function GetMediaListResponseFromJSON(json: any): GetMediaListResponse {
    return GetMediaListResponseFromJSONTyped(json, false);
}

export function GetMediaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaListName': json['media_list_name'],
        'fromEmail': json['from_email'],
        'senderName': json['sender_name'],
        'updatedAt': json['updated_at'],
    };
}

export function GetMediaListResponseToJSON(value?: GetMediaListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_list_name': value.mediaListName,
        'from_email': value.fromEmail,
        'sender_name': value.senderName,
        'updated_at': value.updatedAt,
    };
}

